module.exports = __webpack_public_path__ + "img/image2.2dee442c.png";